import * as React from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { INumberInputProps } from "../../../../../interfaces/advancedSearch/INumberInputProps";
import { ITextStyles } from "@fluentui/react";

export const PercentageFieldInput: React.FunctionComponent<INumberInputProps> = props => {
  const handleOnChange = React.useCallback((event: any, newValue?: string) => {
    props.handleValueChange(props.searchInputData?.index, newValue);
  }, []);

  const textStyles: Partial<ITextStyles> = { root: { width: "100%" } };

  return (
    <TextField
      label={props.displayName + " %"}
      type="number"
      // min={props.min ?? 0}
      // max={props.max * 100}
      styles={textStyles}
      value={props.searchInputData?.value ?? ""}
      className="xb-sp-input"
      onChange={handleOnChange}
    />
  );
};

export default PercentageFieldInput;
